import React, { useRef, useEffect } from 'react';
import { useReactToPrint } from 'react-to-print';
import { format } from 'date-fns';
import logo from '../images/logo.png';
import { StorageData } from '../types/storage';

interface Props {
  data: StorageData;
  onPrintComplete?: () => void;
}

const PrintLabel: React.FC<Props> = ({ data, onPrintComplete }) => {
  const componentRef = useRef<HTMLDivElement>(null);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: `${data.musteri}-${data.no}`,
    pageStyle: `
      @page { 
        size: A4;
        margin: 8mm;
      }
      @media print {
        html, body {
          margin: 0;
          padding: 0;
        }
        .print-content {
          width: 100%;
        }
        table { 
          page-break-inside: avoid;
        }
      }
    `,
    onAfterPrint: onPrintComplete
  });

  useEffect(() => {
    setTimeout(handlePrint, 250);
  }, []);

  const Label = () => (
    <div style={{ marginBottom: '6mm' }}>
      <table style={{ 
        width: '100%', 
        borderCollapse: 'collapse', 
        border: '2px solid black',
        height: '32mm',
        tableLayout: 'fixed'
      }}>
        <tbody>
          <tr style={{ height: '8mm' }}>
            <td style={{ width: '12%', padding: '4px', borderRight: '2px solid black', borderBottom: '2px solid black' }}>
              <div style={{ fontSize: '10px', color: '#666' }}>DEPO ve NO</div>
              <div style={{ fontSize: '18px', fontWeight: 'bold' }}>{data.depo}</div>
            </td>
            <td style={{ width: '12%', padding: '4px', borderRight: '2px solid black', borderBottom: '2px solid black' }}>
              <div style={{ fontSize: '10px', color: '#666' }}>MÜŞTERİ</div>
            </td>
            <td style={{ padding: '4px', borderBottom: '2px solid black' }}>
              <div style={{ 
                fontSize: '28px', 
                fontWeight: 'bold', 
                textAlign: 'center',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
              }}>{data.musteri}</div>
            </td>
            <td style={{ width: '25%', padding: '4px', borderLeft: '2px solid black', borderBottom: '2px solid black', textAlign: 'right' }}>
              <div style={{ 
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
              }}>
                {data.telefon}
              </div>
            </td>
          </tr>
          <tr style={{ height: '8mm' }}>
            <td rowSpan={3} style={{ 
              padding: '4px', 
              borderRight: '2px solid black',
              textAlign: 'center',
              verticalAlign: 'middle'
            }}>
              <div style={{ fontSize: '40px', fontWeight: 'bold' }}>{data.no}</div>
            </td>
            <td style={{ padding: '4px', borderRight: '2px solid black', borderBottom: '2px solid black' }}>
              <div style={{ fontSize: '10px', color: '#666' }}>ADET</div>
            </td>
            <td style={{ padding: '4px', borderBottom: '2px solid black' }}>
              <div style={{ fontSize: '18px', fontWeight: 'bold', textAlign: 'center' }}>{data.adet}</div>
            </td>
            <td style={{ padding: '4px', borderLeft: '2px solid black', borderBottom: '2px solid black', textAlign: 'right' }}>
              <div style={{ 
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
              }}>
                {format(new Date(data.tarih), 'dd.MM.yyyy')}
              </div>
            </td>
          </tr>
          <tr style={{ height: '8mm' }}>
            <td style={{ padding: '4px', borderRight: '2px solid black', borderBottom: '2px solid black' }}>
              <div style={{ fontSize: '10px', color: '#666' }}>LASTİK</div>
            </td>
            <td style={{ padding: '4px', borderBottom: '2px solid black' }}>
              <div style={{ 
                fontSize: '18px', 
                fontWeight: 'bold', 
                textAlign: 'center',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
              }}>{data.ebat}</div>
            </td>
            <td style={{ padding: '4px', borderLeft: '2px solid black', borderBottom: '2px solid black', textAlign: 'right', fontWeight: 'bold' }}>
              <div style={{ 
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
              }}>
                {data.marka}
              </div>
            </td>
          </tr>
          <tr style={{ height: '8mm' }}>
            <td style={{ padding: '4px', borderRight: '2px solid black' }}>
              <div style={{ fontSize: '10px', color: '#666' }}>ARAÇ</div>
            </td>
            <td style={{ padding: '4px' }}>
              <div style={{ 
                fontSize: '18px', 
                fontWeight: 'bold', 
                textAlign: 'center',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
              }}>{data.plaka}</div>
            </td>
            <td style={{ padding: '4px', borderLeft: '2px solid black', textAlign: 'right', fontWeight: 'bold' }}>
              <div style={{ 
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
              }}>
                {data.arac}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );

  return (
    <div ref={componentRef} className="print-content">
  
      {/* İlk 4 label */}
      {[...Array(4)].map((_, index) => (
        <Label key={index} />
      ))}

      {/* 5. label'dan önce logo ve yazı */}
      <div style={{ marginBottom: '6mm' }}>
        <table style={{ 
          width: '100%', 
          borderCollapse: 'collapse', 
          border: '2px solid black',
          height: '20mm'
        }}>
          <tbody>
            <tr>
              <td style={{ 
                padding: '8px', 
                textAlign: 'center',
                verticalAlign: 'middle'
              }}>
                <img src={logo} alt="Logo" style={{ height: '30px', marginBottom: '4px' }} />
                <div style={{ fontSize: '16px', fontWeight: 'bold' }}>
                  ÇELİKLER OTO LASTİK - LASTİK SAKLAMA FİŞİ
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* 5. label */}
      <Label />
      <div style={{ marginBottom: '6mm' }}>
        <table style={{ 
          width: '100%', 
          borderCollapse: 'collapse', 
          border: '2px solid black',
          height: '20mm'
        }}>
          <tbody>
            <tr>
              <td style={{ 
                padding: '8px', 
                textAlign: 'center',
                verticalAlign: 'middle'
              }}>
                <div style={{ marginTop: '4mm', fontSize: '16px', textAlign: 'center', color: '#666', fontWeight: 'bold'}}>
                  <div>NOT: DEPOLAMA SÜRESİ 1 YILI AŞAN LASTİKLERDEN FİRMAMIZ SORUMLU DEĞİLDİR.</div>
                  <div>ÇELİKLER OTO LASTİK 05334327909 - ÜMİT ÇELİK</div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  );
};

export default PrintLabel; 